module.exports = __webpack_public_path__ + "img/public-schema-img-03.1f500c9f.jpg";